/* PassPilot: "Ask a parent to pay" WhatsApp button under every Pass Pack offer in the practice app.
   Most players are young and many have no bank card, so the link sends a parent to /pages/parents (or /pages/ouers in Afrikaans). */
(function () {
  'use strict';
  var scr = document.getElementById('pp-screen'), bd = document.getElementById('pp-backdrop');
  if (!scr && !bd) return;
  var dataEl = document.getElementById('pp-data'), DATA = {};
  try { if (dataEl) DATA = JSON.parse(dataEl.textContent) || {}; } catch (e) { DATA = {}; }
  if (DATA.access) return;
  function lang() { var b = document.getElementById('pp-lang'); return b && b.textContent.trim() === 'EN' ? 'af' : 'en'; }
  var T = {
    en: { btn: 'Ask a parent to pay (WhatsApp)', msg: "Hi! I'm practising for my learner's licence test on PassPilot. Please can you help me get the Pass Pack? It's {price} once-off for 90 days, no debit order, and there's a 5-day money-back. Please use my email address at checkout so it opens on my phone. More info: {url}" },
    af: { btn: "Vra 'n ouer om te betaal (WhatsApp)", msg: "Hallo! Ek oefen vir my learner's op PassPilot. Sal jy my asseblief help om die Pass Pack te kry? Dis {price}, een keer betaal vir 90 dae, geen debietorder nie, en 5 dae geld terug. Gebruik asseblief my e-posadres by die betaalblad sodat dit op my foon oopmaak. Meer inligting: {url}" }
  };
  var PARENTS = { en: 'https://passpilot.shop/pages/parents?utm_source=whatsapp&utm_medium=share&utm_campaign=ask_parent', af: 'https://passpilot.shop/pages/ouers?utm_source=whatsapp&utm_medium=share&utm_campaign=ask_parent_af' };
  function link(where) {
    var t = T[lang()] || T.en, a = document.createElement('a');
    a.className = 'pp-btn pp-btn-white pp-btn-block pp-ask';
    a.target = '_blank';
    a.rel = 'noopener';
    a.href = 'https://wa.me/?text=' + encodeURIComponent(t.msg.replace('{price}', DATA.price || 'R99').replace('{url}', PARENTS[lang()] || PARENTS.en));
    a.textContent = t.btn;
    a.setAttribute('data-where', 'ask_' + where);
    a.style.marginTop = '8px';
    a.addEventListener('click', function () {
      try {
        var s = window.Shopify && window.Shopify.analytics;
        if (s && s.publish) { var p = s.publish('passpilot:parent_link', { where: where, lang: lang(), page: location.pathname }); if (p && p.catch) p.catch(function () {}); }
      } catch (e) {}
    });
    return a;
  }
  function addTo(root, where) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('a[href*="pass-pack"]'), function (b) {
      if (b.getAttribute('data-ppask') || !b.parentNode) return;
      b.setAttribute('data-ppask', '1');
      b.parentNode.insertBefore(link(where), b.nextSibling);
    });
  }
  function scan() {
    if (scr) Array.prototype.forEach.call(scr.querySelectorAll('.pp-offer'), function (o) { addTo(o, 'offer'); });
    if (bd && !bd.hidden) addTo(bd.querySelector('.pp-sheet'), 'sheet');
  }
  var mo = new MutationObserver(scan);
  if (scr) mo.observe(scr, { childList: true, subtree: true });
  if (bd) mo.observe(bd, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  scan();
})();